var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreVerticalWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99984 4.66667C8.73584 4.66667 9.33317 4.06933 9.33317 3.33333C9.33317 2.59733 8.73584 2 7.99984 2C7.26384 2 6.6665 2.59733 6.6665 3.33333C6.6665 4.06933 7.26384 4.66667 7.99984 4.66667ZM8 6.66667C7.264 6.66667 6.66667 7.264 6.66667 8C6.66667 8.736 7.264 9.33333 8 9.33333C8.736 9.33333 9.33333 8.736 9.33333 8C9.33333 7.264 8.736 6.66667 8 6.66667ZM6.66667 12.6665C6.66667 11.9305 7.264 11.3332 8 11.3332C8.736 11.3332 9.33333 11.9305 9.33333 12.6665C9.33333 13.4025 8.736 13.9999 8 13.9999C7.264 13.9999 6.66667 13.4025 6.66667 12.6665Z",
    fill: "#FDFDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVerticalWhite);
export default __webpack_public_path__ + "static/media/MoreVerticalWhite.479b83a54fb63ec80197c6b084eb56cc.svg";
export { ForwardRef as ReactComponent };